import { useContext } from 'react';
import { WidgetHost } from '@/core/widgets/model/widget-host';
import { WidgetHostContext } from '@/core/widgets/contexts/widget-host-context';

export default function useWidgetHost() {
  return useContext<WidgetHost>(WidgetHostContext);
}
